import { render, staticRenderFns } from "./ActivityRetentionRule.vue?vue&type=template&id=2c6cf39d&scoped=true&"
import script from "./ActivityRetentionRule.vue?vue&type=script&lang=js&"
export * from "./ActivityRetentionRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6cf39d",
  null
  
)

export default component.exports